// extracted by mini-css-extract-plugin
module.exports = {"button":"buttons_button__vvi2I"};